/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceIdOrdersGetCollectionTimestamp } from './invoiceIdOrdersGetCollectionTimestamp';
import { OrderPermitRefsInner } from './orderPermitRefsInner';
import { SettingsIdOrdersGetCollectionTimestamp } from './settingsIdOrdersGetCollectionTimestamp';
import { LineItemIdOrdersGetCollectionTimestamp } from './lineItemIdOrdersGetCollectionTimestamp';
import { UserIdOrdersGetCollectionTimestamp } from './userIdOrdersGetCollectionTimestamp';


/**
 * 
 */
export interface OrderIdOrdersGetCollectionTimestamp { 
    userAccount?: UserIdOrdersGetCollectionTimestamp | null;
    lineItems?: Array<LineItemIdOrdersGetCollectionTimestamp>;
    subtotal?: string | null;
    total?: string | null;
    shipping?: string | null;
    fees?: string | null;
    gstIncluded?: string | null;
    feesExplanation?: string | null;
    status: OrderIdOrdersGetCollectionTimestamp.StatusEnum;
    origin?: OrderIdOrdersGetCollectionTimestamp.OriginEnum;
    outstanding?: string | null;
    dateCompleted?: string | null;
    paymentMethod?: OrderIdOrdersGetCollectionTimestamp.PaymentMethodEnum | null;
    stripePaymentIntent?: string | null;
    settingsApplied?: SettingsIdOrdersGetCollectionTimestamp | null;
    invoice?: InvoiceIdOrdersGetCollectionTimestamp | null;
    nbr?: string;
    id?: string | null;
    created?: string;
    updated?: string;
    readonly lineItemTotal?: string;
    /**
     * Gross received - what came in, before anything went back.
     */
    readonly amountPaid?: string;
    /**
     * What has been given back on this order.
     */
    readonly amountRefunded?: string;
    /**
     * Received less refunded - what TLC actually kept.
     */
    readonly netAmountPaid?: string;
    /**
     * Has any money gone back on this order? Drives the CRM badge.
     */
    readonly refunded?: boolean;
    /**
     * What\'s still owed, derived from the ledger. Falls back to the stored value for orders taken before the ledger existed (and for any flow that never records a Payment), so nothing that worked before changes behaviour.
     */
    readonly outstandingFromPayments?: string;
    readonly fullyPaid?: boolean;
    /**
     * The permits this payment is for, so the Payments list can show a permit number instead of the internal order id (TLC, 30 Sep). One entry per permit line item, deduped; `number` is null while a permit is still awaiting its number (assessed types get it only on approval), so the row can say \"not issued yet\" rather than read as a non-permit order. Non-permit lines (e.g. a cultural-advisor fee) are left out. Serialised on the collection because the list needs it without opening each row.
     */
    permitRefs?: Array<OrderPermitRefsInner>;
    readonly originLabel?: string | null;
}
export namespace OrderIdOrdersGetCollectionTimestamp {
    export type StatusEnum = 'PENDING' | 'COMPLETE' | 'CANCELLED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Complete: 'COMPLETE' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum
    };
    export type OriginEnum = 'WEB' | 'IN_PERSON';
    export const OriginEnum = {
        Web: 'WEB' as OriginEnum,
        InPerson: 'IN_PERSON' as OriginEnum
    };
    export type PaymentMethodEnum = 'EFT' | 'CASH';
    export const PaymentMethodEnum = {
        Eft: 'EFT' as PaymentMethodEnum,
        Cash: 'CASH' as PaymentMethodEnum
    };
}


